module.exports = __webpack_public_path__ + "static/img/arcode-wx.b59552a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/arcode-wx.png
// module id = xE1C
// module chunks = 0